// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unGGI_oBmQg74Xu8VwXh{width:44px;height:40px;color:var(--content-primary-tertiary);cursor:pointer;border-radius:6px;justify-content:center;align-items:center;margin-bottom:2px;font-size:18px;display:flex}.unGGI_oBmQg74Xu8VwXh.obrqW6bVMIzxIhaIVx7H,.unGGI_oBmQg74Xu8VwXh:hover{background:var(--background-neutral-default);color:var(--content-primary-tertiary)}.unGGI_oBmQg74Xu8VwXh.obrqW6bVMIzxIhaIVx7H{box-shadow:0 4px 12px -2px rgba(18,19,23,.03)}.DWugi6I_RwgfqXH6PwYZ{height:423px}.DWugi6I_RwgfqXH6PwYZ .C8qGveITw6E3GCt2MEBo{border:none;height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `unGGI_oBmQg74Xu8VwXh`,
	"active": `obrqW6bVMIzxIhaIVx7H`,
	"iframeWrapper": `DWugi6I_RwgfqXH6PwYZ`,
	"iframe": `C8qGveITw6E3GCt2MEBo`
};
export default ___CSS_LOADER_EXPORT___;
